__turbopack_context__.v({
  "cardBody": "images-module-scss-module__Xhrvtq__cardBody",
  "closeImg": "images-module-scss-module__Xhrvtq__closeImg",
  "customIcon": "images-module-scss-module__Xhrvtq__customIcon",
  "image": "images-module-scss-module__Xhrvtq__image",
  "linkIcon": "images-module-scss-module__Xhrvtq__linkIcon",
  "loaderThree": "images-module-scss-module__Xhrvtq__loaderThree",
  "loaderTwo": "images-module-scss-module__Xhrvtq__loaderTwo",
  "loadingModal": "images-module-scss-module__Xhrvtq__loadingModal",
  "modalContent": "images-module-scss-module__Xhrvtq__modalContent",
  "modalDialog": "images-module-scss-module__Xhrvtq__modalDialog",
});
